import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Menu as MUIMenu, MenuItem as MUIMenuItem } from '@mui/material';
import React from 'react';
import { ix } from '../../../utils/ix';
import { Typography } from '../../electrons';
import { Button } from '../Button';
import { useStyles } from './DropdownButton.styles';
export const DropdownButton = (props) => {
    const { id, className, buttonText, menuItems, disabled } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const classes = useStyles();
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleItemClick = (event, item) => {
        if (item.onClick) {
            item.onClick(event);
        }
        handleClose();
    };
    return (React.createElement("div", { id: id, className: className },
        React.createElement(Button, { id: ix(id, 'button'), variant: props.variant || 'contained', onClick: handleClick, disabled: disabled },
            buttonText,
            React.createElement(ExpandMoreIcon, { fontSize: "small", sx: {
                    marginLeft: '4px',
                    marginRight: '-4px',
                } })),
        React.createElement(MUIMenu, { id: ix(id, 'menu'), open: open, anchorEl: anchorEl, onClose: handleClose, classes: {
                paper: classes.menuPaper,
                list: classes.menuList,
            } }, menuItems &&
            menuItems.map((item) => (React.createElement(MUIMenuItem, { id: item.id, key: item.id, onClick: (event) => handleItemClick(event, item), disabled: item.disabled },
                React.createElement(Typography, { variant: "body2" }, item.label)))))));
};
export default DropdownButton;
//# sourceMappingURL=DropdownButton.js.map